var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifeAndPeopleLuggage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-2352.000000, -2179.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Life-and-people/Luggage",
    transform: "translate(2352.000000, 2179.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,30 C12.6,30 13,30.4 13,31 C13,31.6 12.6,32 12,32 C11.4,32 11,31.6 11,31 C11,30.4 11.4,30 12,30 Z M21,30 C21.6,30 22,30.4 22,31 C22,31.6 21.6,32 21,32 C20.4,32 20,31.6 20,31 C20,30.4 20.4,30 21,30 Z M24,9 L24,27 C24,28.1 23.1,29 22,29 L22,29 L11,29 C9.9,29 9,28.1 9,27 L9,27 L9,9 L24,9 Z M13,12 L12,12 L12,26 L13,26 L13,12 Z M17,12 L16,12 L16,26 L17,26 L17,12 Z M21,12 L20,12 L20,26 L21,26 L21,12 Z M19,0 C19.6,0 20,0.4 20,1 L20,1 L20,8 L19,8 L19,2 L14,2 L14,8 L13,8 L13,1 C13,0.4 13.4,0 14,0 L14,0 Z",
    id: 298
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeAndPeopleLuggage);
export default __webpack_public_path__ + "static/media/life-and-people-luggage.fa9c091c.svg";
export { ForwardRef as ReactComponent };